import {useFetchOneEntry} from '../useFetchOneEntry'
import builderConfig from 'hec/builder/model-map'

const useFetchParentGoal = ({levelContentId, apiKey, shouldQuery, fields}) =>
    useFetchOneEntry({
        queryKey: ['Builder-Fetch-Learning-Center-Parent-Goal', levelContentId],
        options: {
            model: builderConfig.learningCenterGoal,
            apiKey: apiKey,
            enrich: false,
            query: {
                data: {
                    levels: {
                        $elemMatch: {
                            'level.id': {$eq: levelContentId}
                        }
                    }
                }
            },
            fields: fields || 'data'
        },
        enabled: !!levelContentId && shouldQuery
    })

export default useFetchParentGoal
